import { CurrentUserI, UserEmploymentStatus } from '../api/users/interfaces/Users';

/**
 * product#87: el usuario es un ex-empleado de su empresa (la empresa le dio de
 * baja) y su plan de empleo ya no puede recibir aportaciones.
 *
 * La señal es `employmentStatus === TERMINATED`, no `status`: `deleted` también
 * es una cuenta borrada y `non-active` también es un alta reciente. Es el mismo
 * criterio de comparsa (`apply-status-filter.ts`).
 *
 * Solo aplica a la vista del plan de EMPLEO: la vista personal no cambia. Si el
 * usuario es además beneficiario con rescate (`isRetiredBeneficiary`), manda la
 * vista de rescate.
 */
export const esExEmpleado = (currentUser?: CurrentUserI | null): boolean =>
	currentUser?.user?.employmentStatus === UserEmploymentStatus.TERMINATED;
